class CartSellingPlanSelect extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('#cart') || document.getElementById('Cart-Drawer');
    // * New cart won after AB test
    this.renderDrawerOnly = !document.querySelector('#cart');
    this.select = this.querySelector('select');
    this.select.addEventListener('change', this.changeCartSellingPlan.bind(this));
    this.selectedSellingPlanValue = this.select.value;
    if (window.location.href.indexOf('/products') !== -1) {
      this.setHiddenInputValue();
    }
  }
  createAddArray() {
    let add_items = [];

    let cart_items = this.cart.querySelectorAll('.cart-item__grid');
    cart_items.forEach((item) => {
      let variant_id = item.dataset.variantId;
      if (!item.querySelector('special-product')) {
        let quantity = item.querySelector('quantity-selector input[type="number"]').value;

        let selling_plan_ids;
        let new_selling_plan_id = null;

        if (item.dataset.sellingPlanIds != undefined) {
          selling_plan_ids = item.dataset.sellingPlanIds.split(',');
        }

        if (this.selectedSellingPlanValue != null && item.dataset.sellingPlanIds != undefined) {
          new_selling_plan_id = selling_plan_ids[this.selectedSellingPlanValue];
          if (!/^\d+$/.test(String(new_selling_plan_id ?? ''))) {
            new_selling_plan_id = null;
          }
        }

        let add_item = {
          id: variant_id,
          quantity,
        };

        if (new_selling_plan_id != null) {
          add_item.selling_plan = Number(new_selling_plan_id);
        }
        add_items.push(add_item);
      } else if (item.querySelector('special-product')) {
        if (item.querySelector("special-product input[type='checkbox'").checked) {
          let add_item = {
            id: variant_id,
            quantity: 1,
          };
          add_items.push(add_item);
        }
      }
    });
    add_items.reverse();
    let add_arrays = splitArray(add_items, 20);
    return add_arrays;
  }
  drawerDisplayError(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  rerenderCartDrawer(newMarkup) {
    const elementToReplace = document.getElementById('Cart-Drawer').querySelector('.side-panel__container');
    elementToReplace.innerHTML = this.getSectionInnerHTML(newMarkup, '.side-panel__container');
  }
  changeCartSellingPlan(event) {
    if (event.target.closest('.sellingplan_tab')?.classList.contains('one-time')) {
      this.selectedSellingPlanValue = null;
    } else {
      this.selectedSellingPlanValue = event.target.value;
    }

    if (this.selectedSellingPlanValue != null) {
      this.selectedSellingPlanValue = Number(this.selectedSellingPlanValue);

      const d = new Date();
      const cookieExpire = d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      document.cookie = `active_selling_plan=${event.target.value};${cookieExpire};`;
    }

    // Change Hidden Input when on PDP
    if (window.location.href.indexOf('/products') !== -1) {
      this.setHiddenInputValue();
    }

    let addArrays = this.createAddArray();
    window.sessionStorage.setItem('add-selling-plan-arrays', JSON.stringify(addArrays));

    fetch(window.Shopify.routes.root + 'cart/clear.js').then((response) => {
      addArrays.forEach((array) => {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: array,
            ...(this.renderDrawerOnly
              ? {
                  sections: ['cart-drawer'],
                }
              : {
                  sections: new Cart().getSectionsToRender().map((section) => section.section),
                  sections_url: window.location.pathname,
                }),
          }),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            if (this.renderDrawerOnly) {
              if (parsedState.errors) {
                this.drawerDisplayError(line, parsedState.errors);
                return;
              }
              this.rerenderCartDrawer(parsedState.sections['cart-drawer']);
            } else {
              if (parsedState.errors) {
                this.displayErrors(line, parsedState.errors);
                this.container.classList.remove('cart-disabled');
                return;
              }
              new Cart().renderContents(parsedState, false, false);
            }
          });
      });
    });
  }
  // Never write a non-numeric selling_plan. Assigning undefined stores the string
  // "undefined", and Shopify rejects the add with
  // "expected String to be a Integer: selling_plan".
  setHiddenInputValue() {
    document.querySelectorAll("input[name='selling_plan']").forEach((input) => {
      if (!/^\d+$/.test(input.value.trim())) {
        input.value = '';
      }
    });
  }
}

customElements.define("cart-selling-plan-select", CartSellingPlanSelect)

function splitArray(array, chunkSize) {
  let result = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    let chunk = array.slice(i, i + chunkSize);
    result.push(chunk);
  }

  return result;
}
